import { additionalInfo } from "@/data/athlete";
import { SectionHeader } from "./_shared";
import { Hash } from "lucide-react";

export const AdditionalInfo = () => {
  return (
    <section
      id="additional-info"
      data-testid="additional-info-section"
      className="border-t border-zinc-900 py-16 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <SectionHeader
          eyebrow="08 — Compliance"
          title="Additional Information"
          kicker="Reference details for recruiters and compliance officers."
          testId="additional-info-header"
        />

        <div
          data-testid="additional-info-grid"
          className="grid md:grid-cols-2 gap-4 md:gap-5"
        >
          <div
            data-testid="additional-info-ncaa"
            className="border border-zinc-800 bg-[#141414] p-5 md:p-6 flex items-start gap-4"
          >
            <Hash className="h-5 w-5 text-[#FF3B30] mt-0.5 shrink-0" />
            <div>
              <div className="text-[10px] md:text-xs uppercase tracking-[0.25em] font-bold text-zinc-500 mb-1">
                NCAA ID
              </div>
              <div className="text-white font-bold text-base md:text-lg tabular-nums">
                {additionalInfo.ncaaId}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
